var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropDMail02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3332 12L9.90468 8.00002M6.09516 8.00002L1.66661 12M1.33325 4.66669L6.77653 8.47698C7.21731 8.78553 7.4377 8.9398 7.67743 8.99956C7.88918 9.05234 8.11066 9.05234 8.32241 8.99956C8.56213 8.9398 8.78252 8.78553 9.2233 8.47698L14.6666 4.66669M4.53325 13.3334H11.4666C12.5867 13.3334 13.1467 13.3334 13.5746 13.1154C13.9509 12.9236 14.2569 12.6177 14.4486 12.2413C14.6666 11.8135 14.6666 11.2535 14.6666 10.1334V5.86669C14.6666 4.74658 14.6666 4.18653 14.4486 3.75871C14.2569 3.38238 13.9509 3.07642 13.5746 2.88467C13.1467 2.66669 12.5867 2.66669 11.4666 2.66669H4.53325C3.41315 2.66669 2.85309 2.66669 2.42527 2.88467C2.04895 3.07642 1.74299 3.38238 1.55124 3.75871C1.33325 4.18653 1.33325 4.74658 1.33325 5.86669V10.1334C1.33325 11.2535 1.33325 11.8135 1.55124 12.2413C1.74299 12.6177 2.04895 12.9236 2.42527 13.1154C2.85309 13.3334 3.41315 13.3334 4.53325 13.3334Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDMail02);
export default __webpack_public_path__ + "static/media/DropD_mail-02.5d165812bd10b3dd1c6250ace70d9b94.svg";
export { ForwardRef as ReactComponent };